module.exports = __webpack_public_path__ + "img/so.6e5f1337.svg";